import { startOfDay, startOfToday } from "date-fns";
import { createContext, useContext } from "react";

export const SelectedDateContext = createContext<{
  selectedDate: Date | undefined;
  setSelectedDate: (_date: Date) => void;
} | null>(null);

export const useSelectedDateNoDefault = () => {
  const selectedDateContext = useContext(SelectedDateContext);
  return selectedDateContext?.selectedDate;
};

export const useSelectedDate = () => {
  return useSelectedDateNoDefault() ?? startOfToday();
};

export const useSelectedDateHasPassed = () => {
  const selectedDate = useSelectedDate();
  const hasPassed = startOfDay(selectedDate) < startOfToday();
  return hasPassed;
};
